/* import __COLOCATED_TEMPLATE__ from './tab-error.hbs'; */
import Component from '@ember/component';

export default class TabError extends Component {
    tagName = '';
}
